import store from '../reducers/index';
import { logout } from '../actions/user';
import { PROGRESSER_URL, SCRIBBLE_URL, WORDPRESS_URL } from './constants';
import isPast from 'date-fns/is_past';

const apps = {
  progresser: PROGRESSER_URL,
  scribble: SCRIBBLE_URL,
  wordpress: WORDPRESS_URL
};

const apiRequest = async (app, endpoint, method = 'GET', body = null) => {
  const { userData } = store.getState().user;

  if (!userData || isPast(userData.expires)) {
    store.dispatch(logout());
    // Normally we should return void here, but because we
    // need the bookData on login page, we can't.
  }

  const response = await fetch(`${apps[app]}/${endpoint}`, {
    method,
    withCredentials: true,
    headers: {
      Authorization:
        app === 'wordpress'
          ? `Bearer ${userData ? userData.token : null}`
          : userData
            ? userData.token
            : null,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: body ? JSON.stringify(body) : undefined
  });

  return response.status === 200 ? response.json() : response;
};

export default apiRequest;



// WEBPACK FOOTER //
// ./src/utils/apiRequest.js